import { useState } from 'react';
import { StandaloneRepairIntakeForm, ReturnPanel } from './RepairLedgerPage';
import type { StandaloneRepairPiece } from './RepairLedgerPage';

export function StandaloneAssetReturnPage() {
  const [piece, setPiece] = useState<StandaloneRepairPiece | null>(null);
  const [registrationOpen, setRegistrationOpen] = useState(true);
  const [returnPanelKey, setReturnPanelKey] = useState(0);
  const [finished, setFinished] = useState(false);

  return (
    <section className="panel">
      <div className="panel-head">
        <div>
          <h2>无法修复工件退回</h2>
          <div className="desc">
            单独登记客户送来的维修工件，无法修复时开退货单并签收归还。此流程不创建 QC 销售订单、销售合同、生产工单或质检单，也不进入公司库存。
          </div>
        </div>
      </div>

      <div style={{ display: 'flex', gap: 8, marginBottom: 10 }}>
        <button className={`btn${registrationOpen ? ' primary' : ''}`} onClick={() => setRegistrationOpen((v) => !v)}>
          {registrationOpen ? '收起新工件登记' : '登记新工件'}
        </button>
      </div>
      {registrationOpen ? (
        <StandaloneRepairIntakeForm onCreated={(registered) => {
          setPiece(registered);
          setRegistrationOpen(false);
          setReturnPanelKey((v) => v + 1);
          setFinished(false);
        }} />
      ) : null}
      {piece ? (
        <div className="notice" style={{ display: 'block', marginTop: 12 }}>
          工件 <b className="num">{piece.customer_serial}</b> 已独立登记为 V1 送修履历；已在下方可退工件列表中选中。
        </div>
      ) : null}
      <div style={{ marginTop: 14 }}>
        <h3>选择已登记工件退货</h3>
        <div className="desc" style={{ marginBottom: 8 }}>此列表只显示独立登记、未进入合同/工单/质检流程且仍有可退数量的工件。销售订单关联工件需回原订单业务链处理。</div>
        <ReturnPanel
          key={returnPanelKey}
          row={{ asset_id: piece?.asset_id ?? '', cycle_id: null, contract_id: null }}
          allReturnable
          onChanged={() => setFinished(true)}
        />
        {finished ? <div className="notice" style={{ marginTop: 10 }}>退货单已签收归还，在厂数量已扣减。</div> : null}
      </div>
    </section>
  );
}
